<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Status Integração
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs items-center"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="recebeUnidade.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Status Envio</div>
        <q-select
          :options="options.statusEnvio"
          dense
          outlined
          class="select"
          v-model="filtros.statusEnvio"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Status Integração</div>
        <q-select
          :options="options.statusIntegracao"
          dense
          outlined
          class="select"
          v-model="filtros.statusIntegracao"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Origem Erro</div>
        <q-select
          :options="options.origemErro"
          dense
          outlined
          class="select"
          v-model="filtros.origemErro"
        />
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Num. Requisição</div>
        <q-input v-model="filtros.requisicaoId" class="input" dense outlined />
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Produto</div>
        <q-input v-model="filtros.produto" class="input" dense outlined />
      </div>
      <div class="col-md-3 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Funcionário</div>
        <q-input v-model="filtros.funcionario" class="input" dense outlined />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          v-model="filtros.dataEntrega"
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataEntrega"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          v-model="filtros.dataAtual"
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataAtual"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Epi</div>
        <q-select
          :options="options.epi"
          dense
          outlined
          class="select"
          v-model="filtros.epi"
        />
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Mensagem</div>
        <q-input
          v-model="filtros.mensagem_erros"
          class="input"
          dense
          outlined
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-xs btn"
          color="primary"
          label="Filtrar"
          no-caps
          icon="filter_alt"
          @click="listarProdutosIntegracao()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Produtos das Requisições Finalizadas
        </span>
        <q-btn
          class="btn-exportar"
          label="Exportar"
          color="secondary"
          no-caps
          icon="file_upload"
          @click="exportarRelatorio()"
        />
      </div>
      <q-table
        :columns="columns"
        :rows="listaProdutos"
        :loading="loading"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        @request="paginarTabela"
        :rows-per-page-label="'Linhas Por Página'"
        v-model:pagination="pagination"
        :rows-per-page-options="[10, 25, 50, 100]"
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID Requisição: </strong>
                    {{ props.row.requisicao_id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Usuário: </strong
                    >{{ props.row.usuario_nome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Produto: </strong
                    >{{ props.row.produto_codigo }}</span
                  >
                  <span
                    v-if="props.row.produto_codigo_integracao"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Int. Produto: </strong
                    >{{ props.row.produto_codigo_integracao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Produto: </strong
                    >{{ props.row.produto_nome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade: </strong
                    >{{ props.row.quantidade }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Entrega: </strong
                    >{{ props.row.data_entrega.split("-").join("/") }}</span
                  >
                  <span
                    v-if="props.row.data_envio"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Envio: </strong
                    >{{ props.row.data_envio.split("-").join("/") }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Enviado: </strong
                    >{{ props.row.enviado }}</span
                  >
                  <span
                    v-if="props.row.numero_erros"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Erros: </strong
                    >{{ props.row.numero_erros }}</span
                  >
                  <span
                    v-if="props.row.mensagem_erros"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Erros: </strong
                    >{{ props.row.mensagem_erros }}</span
                  >
                </div>
                <div class="col-2">
                  <div>
                    <q-btn
                      v-if="props.row.enviado == 0"
                      :disable="disable"
                      icon="arrow_upward"
                      round
                      color="positive"
                      @click="enviar(props.row.id, 'EntregarEpiJob')"
                    />
                    <q-btn
                      v-if="
                        props.row.enviado == 1 && props.row.numero_erros >= 1
                      "
                      :disable="disable"
                      icon="arrow_upward"
                      round
                      color="yellow-6"
                      @click="
                        enviar(
                          props.row.id,
                          'ReprocessarIntegracaoRequisicaoJob'
                        )
                      "
                    />
                    <q-btn
                      v-if="
                        props.row.enviado == 1 && props.row.numero_erros == 0
                      "
                      disable
                      icon="arrow_upward"
                      round
                      color="red-6"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-idrequisicao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.requisicao_id }}
          </q-td>
        </template>
        <template v-slot:body-cell-idsap="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.usuario_matricula }}
          </q-td>
        </template>
        <template v-slot:body-cell-usuario="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.usuario_nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-codproduto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.produto_codigo }}
          </q-td>
        </template>
        <template v-slot:body-cell-codintproduto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.produto_codigo_integracao }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidade }}
          </q-td>
        </template>
        <template v-slot:body-cell-dataentrega="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.data_entrega.split("-").join("/") }}
          </q-td>
        </template>
        <template v-slot:body-cell-dataenvio="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.data_envio
                ? props.row.data_envio.split("-").join("/")
                : ""
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-enviado="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.enviado }}
          </q-td>
        </template>
        <template v-slot:body-cell-erros="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.numero_erros }}
          </q-td>
        </template>
        <template v-slot:body-cell-mensagem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.mensagem_erros }}
          </q-td>
        </template>
        <template v-slot:body-cell-produto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.produto_nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-integrar="props">
          <q-td :props="props">
            <q-btn
              v-if="props.row.enviado == 0"
              :disable="disable"
              icon="arrow_upward"
              round
              color="positive"
              @click="enviar(props.row.id, 'EntregarEpiJob')"
            />
            <q-btn
              v-if="props.row.enviado == 1 && props.row.numero_erros >= 1"
              :disable="disable"
              icon="arrow_upward"
              round
              color="yellow-6"
              @click="
                enviar(props.row.id, 'ReprocessarIntegracaoRequisicaoJob')
              "
            />
            <q-btn
              v-if="props.row.enviado == 1 && props.row.numero_erros == 0"
              disable
              icon="arrow_upward"
              round
              color="red-6"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "idrequisicao",
    label: "ID Requisição",
    align: "left",
  },
  {
    name: "idsap",
    label: "ID/SAP",
    align: "left",
  },
  {
    name: "usuario",
    label: "Usuário",
    align: "left",
  },
  {
    name: "codproduto",
    label: "Cod. Produto",
    align: "left",
  },
  {
    name: "codintproduto",
    label: "Cod. Int. Produto",
    align: "left",
  },
  {
    name: "produto",
    label: "Produto",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    align: "left",
  },
  {
    name: "dataentrega",
    label: "Data Entrega",
    align: "left",
  },
  {
    name: "dataenvio",
    label: "Data Envio",
    align: "left",
  },
  {
    name: "enviado",
    label: "Enviado",
    align: "left",
  },
  {
    name: "erros",
    label: "Erros",
    align: "left",
  },
  {
    name: "mensagem",
    label: "Mensagem",
    align: "left",
  },
  {
    name: "integrar",
    label: "Integrar",
    align: "center",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    let quasar = useQuasar();
    let disable = ref(false);
    let loading = ref(false);
    const listaProdutos = ref([]);
    const pagination = ref({
      sortBy: "desc",
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const filtros = ref({
      statusEnvio: {
        label: "Não Enviados",
        value: 0,
      },
      statusIntegracao: {
        label: "Todas",
        value: 0,
      },
      origemErro: {
        label: "Todas",
        value: 0,
      },
      requisicaoId: "",
      funcionario: "",
      produto: "",
      dataEntrega: "",
      epi: "",
      mensagem_erros: "",
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const options = {
      statusEnvio: [
        { label: "Não Enviados", value: 0 },
        { label: "Enviadas", value: 1 },
      ],
      statusIntegracao: [
        { label: "Todas", value: 0 },
        { label: "Com Erro", value: 1 },
      ],
      origemErro: [
        { label: "Todas", value: 0 },
        { label: "Apenas Integração", value: 1 },
      ],
      epi: [
        { label: "SIM", value: "sim" },
        { label: "TODOS", value: "" },
      ],
    };

    const listarProdutosIntegracao = async (page = 1, rowsPerPage = 10) => {
      try {
        disable.value = true;
        loading.value = true;
        const response = await store.dispatch(
          "integracao/listarProdutosIntegracao",
          {
            apenas_soc: filtros.value.origemErro.value,
            enviado: filtros.value.statusEnvio.value,
            erros: filtros.value.statusIntegracao.value,
            unidade_id: recebeUnidade.value.id,
            requisicao_id: filtros.value.requisicaoId,
            epi: filtros.value.epi.value,
            per_page: rowsPerPage,
            data_inicial: filtros.value.dataEntrega,
            data_final: filtros.value.dataAtual,
            solicitante: filtros.value.funcionario,
            produto: filtros.value.produto,
            mensagem_erros: filtros.value.mensagem_erros,
            page: page,
          }
        );
        listaProdutos.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const enviar = async (id, job) => {
      if (
        store.state.autenticacao.cliente.includes("staging-cerradinho") ||
        store.state.autenticacao.cliente.includes("cerradinho")
      ) {
        if (job == "EntregarEpiJob") {
          store.dispatch("integracao/integrarProdutoCerradinhoEnvio");
          quasar.notify({
            message: "Syncrionizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          setTimeout(() => {
            listarProdutosIntegracao();
          }, 1000);
          return;
        } else if (job == "ReprocessarIntegracaoRequisicaoJob") {
          store.dispatch("integracao/integrarProdutoCerradinhoReenvio");
          quasar.notify({
            message: "Reeprocessado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        setTimeout(() => {
          listarProdutosIntegracao();
        }, 1000);

        return;
      }

      // lógica especifica para tenants "pg" e "staging-pg"
      if (
        store.state.autenticacao.cliente.includes("staging-pg") ||
        store.state.autenticacao.cliente.includes("pg")
      ) {
        try {
          await store.dispatch("integracao/reprocessarJob", {
            integrationConsumptionIds: [id],
          });
          quasar.notify({
            message: "Produto enviado para processamento",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          setTimeout(() => {
            listarProdutosIntegracao();
          }, 1000);
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro ao processar produto",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        return;
      }

      // Lógica padrão para demais clientes
      try {
        await store.dispatch("integracao/integrarProduto", {
          job: job,
          id: id,
        });
        quasar.notify({
          message: "Produto enviado para processamento",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        setTimeout(() => {
          listarProdutosIntegracao();
        }, 1000);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao processar produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = (props) => {
      listarProdutosIntegracao(
        props.pagination.page,
        props.pagination.rowsPerPage
      );
    };

    const exportarRelatorio = async () => {
      try {
        await store.dispatch("integracao/listarProdutosIntegracao", {
          apenas_soc: filtros.value.origemErro.value,
          enviado: filtros.value.statusEnvio.value,
          erros: filtros.value.statusIntegracao.value,
          unidade_id: recebeUnidade.value.id,
          requisicao_id: filtros.value.requisicaoId,
          download: "xlsx",
          epi: filtros.value.epi?.value,
          data_inicial: filtros.value.dataEntrega,
          data_final: filtros.value.dataAtual,
          solicitante: filtros.value.funcionario,
          produto: filtros.value.produto,
        });
        quasar.notify({
          message:
            "Seu relatório esta sendo preparado, você receberá um link no email, ou acesse a central de downloads para baixar.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao enviar relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const gerarDataEntrega = () => {
      const hoje = new Date();
      const dataAtual = new Date(hoje);
      dataAtual.setDate(hoje.getDate() - 15);

      const dd = String(dataAtual.getDate()).padStart(2, "0");
      const mm = String(dataAtual.getMonth() + 1).padStart(2, "0");
      const yyyy = dataAtual.getFullYear();

      filtros.value.dataEntrega = dd + "/" + mm + "/" + yyyy;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        listarProdutosIntegracao();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(() => {
      gerarDataEntrega();
      getUnidade();
    });

    onMounted(listarProdutosIntegracao);

    return {
      columns,
      options,
      filtros,
      recebeUnidade,
      listarProdutosIntegracao,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      listaProdutos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      paginarTabela,
      enviar,
      exportarRelatorio,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
tbody tr td {
  white-space: pre-wrap;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
}
</style>
